/**
 * Custom Month Event Component for Calendar
 */

import React from 'react';

const formatCompact = (amount) => {
  if (!amount) return '';
  if (amount >= 1_000_000) return (amount / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
  if (amount >= 1_000) return Math.round(amount / 1_000) + 'K';
  return String(amount);
};

const CustomMonthEvent = ({ event }) => {
  if (!event.resource) {
    return <span className="block truncate">{event.title}</span>;
  }

  const eventType = event.resource.event_type;

  if (eventType === 'lunar_holiday') {
    return (
      <span className="lunar-event-content block truncate" title={event.title}>
        {event.title}
      </span>
    );
  }

  if (eventType === 'payment_due') {
    let metadata = event.resource.metadata || {};
    if (typeof metadata === 'string') {
      try { metadata = JSON.parse(metadata); } catch { metadata = {}; }
    }

    // Aggregated summary chip ("💸 11 phòng đến hạn") — render the title as-is.
    if (event.resource.aggregated || (metadata.items && metadata.count)) {
      return (
        <span className="block truncate" title={event.title}>
          {event.title}
        </span>
      );
    }

    let roomNumber = metadata.room_number;
    if (!roomNumber && event.title) {
      const match = event.title.match(/:\s*([A-Z]?\d+)/);
      if (match) roomNumber = match[1];
    }

    if (!roomNumber) return null;

    const status = event.resource.status || 'pending';
    const isPaid = status === 'completed' || status === 'paid';
    const amountCompact = formatCompact(metadata.amount);

    return (
      <span className="calendar-event-payment">
        <span className="room-label"><span className="event-r-prefix">R.</span>{roomNumber}</span>
        {amountCompact && (
          <span className="amount-label">{amountCompact}</span>
        )}
        {isPaid && <span className="paid-badge">✓</span>}
      </span>
    );
  }

  return <span className="block truncate">{event.title}</span>;
};

export default CustomMonthEvent;
